import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import EconomicGroupAdditionalInfo from './economicGroupAdditionalInfo';
import EconomicGroupStructure from './economicGroupStructure';
import EconomicGroupDetail from './economicGroupDetail';
import ExcelExportButton from '../../common/excelExportButton';
import EvalSummary from './evalSummary';
import BbPopover from '../../common/popover'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "./economicGroup.scss"

class EconomicGroupEvaluation extends React.Component {
    mounted = false;
    state = {
        loaded: false
    }

    render() {
        return this.state.loaded && this.props.data && this.props.data.evaluation ? this.renderWithData() : null;
    }

    renderWithData() {
        let popoverId = 'popoverId';
        return (
            <div>
                <div style={{float: 'right'}}>
                    <span>
                        <BbPopover title={this.props.translate("Title.Economic.Group.Evaluation")} addInfo={'ESS'} placement="left" targetId={popoverId} style={{maxWidth: "400px;"}}>
                            <span href="#" className="icon-gray print-hidden" id={popoverId} style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" /></span>
                        </BbPopover>
                    </span>
                </div>
                <div className="eval-summaries">
                    <EvalSummary evaluation={this.props.data.evaluation.total} />
                    <EvalSummary evaluation={this.props.data.evaluation.finalOwners} />
                    <EvalSummary evaluation={this.props.data.evaluation.neighborhood} />
                    <EvalSummary evaluation={this.props.data.evaluation.subject} />
                </div>

                <EconomicGroupStructure data={this.props.data.evaluation} />
                <EconomicGroupDetail data={this.props.data.evaluation} />
                <EconomicGroupAdditionalInfo data={this.props.data.additionalInfo} />
                <ExcelExportButton link="economic-group-evaluation" entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }
    componentDidMount() {
        this.mounted = true;
        if (this.mounted) {
            if (this.props.data !== undefined && this.props.data !== null) {
                this.setState({ loaded: true });
            }
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(EconomicGroupEvaluation));